import React from 'react';
import { type BuyerLayoutProps } from 'shop-ui/types';

interface ProductSummaryProps extends BuyerLayoutProps<Product> {}

export const ProductSummary: React.FC<ProductSummaryProps> = (props) => {
    const { __ssr = {} } = props;

    const { product } = __ssr;

    const summary = product?.summary;

    if (!summary) {
        return null;
    }

    return (
        <div className="skeleton skeleton--ssr skeleton--sm">
            <p className="ssr-hidden">{summary}</p>
        </div>
    );
};
